/** The range of every new price before fees: products, private offers, plans and tips. */
export const PRICE_MIN = 5;
export const PRICE_MAX = 999;

/** The amounts every tip picker offers before Other. */
export const TIP_TIERS: readonly number[] = [5, 10, 50];

/** Why a new price cannot be used, or null. */
export function priceProblem(price: number): string | null {
  if (!(price >= PRICE_MIN)) return `The minimum price is $${PRICE_MIN}`;
  if (price > PRICE_MAX) return `The maximum price is $${PRICE_MAX}`;
  return null;
}

/** A price we derive rather than one a person typed, pulled into the range. */
export const clampPrice = (price: number): number =>
  Math.min(PRICE_MAX, Math.max(PRICE_MIN, Math.round(price)));
